import React from "react";
import styles from "./Offer.module.css";

export default function Offer() {
  return <div className={styles.sectionContent}>
      <div className={styles.offer}>
        <p>
          {"Promocja".toUpperCase()}! Zmień u nas opony i dostań 10% {"zniżki".toUpperCase()} na wymianę oleju silnikowego.
        </p>
        <p>
          {"Promocja".toUpperCase()}! Zmień u nas opony i dostań 10% {"zniżki".toUpperCase()} na wymianę oleju silnikowego.
        </p>
        <p>
          {"Promocja".toUpperCase()}! Zmień u nas opony i dostań 10% {"zniżki".toUpperCase()} na wymianę oleju silnikowego.
        </p>
      </div>
    </div>;
}
